import React from "react";
import themeState from "./state/themeState";
import {observer} from "mobx-react";
import fakePointerRegister from "./state/fakePointerRegister";
import {mouseState} from "./state/mouseState";

const LimitedTouchAreaButton = observer(
    class extends React.Component {
        constructor(props) {
            super(props);
            this.scale = this.props.scale ? this.props.scale : 1
            this.state = {clicked: false}
        }

        componentDidMount() {
            fakePointerRegister.register(this.props.id, this.onClick.bind(this))
        }

        componentWillUnmount() {
            fakePointerRegister.unregister(this.props.id)
        }

        onClick(evt) {
            if (evt.type === "mousedown" && this.props.onClick !== undefined && this.checkTouchArea(mouseState.mouse_x - window.scrollX, mouseState.mouse_y - window.scrollY)) {
                this.props.onClick()
            }
            this.setState({clicked: !this.state.clicked})
        }

        checkTouchArea(x, y) {
            let rect = document.getElementById(this.props.id).getBoundingClientRect()

            let size_x = Math.abs(rect.left - rect.right) / 2
            let size_y = Math.abs(rect.top - rect.bottom) / 2

            let center_x = (rect.left + rect.right) / 2
            let center_y = (rect.top + rect.bottom) / 2

            let x_diff = Math.abs(x - center_x)
            let y_diff = Math.abs(y - center_y)
            return ((size_x * this.scale) > x_diff) && ((size_y * this.scale) > y_diff)

        }

        render() {
            return <button
                onClick={fakePointerRegister.dud}
                style={{
                    cursor: "none",
                    minWidth: "10%",
                    maxWidth: "10%",
                    backgroundColor: !this.state.clicked ? themeState.colour_primary : themeState.colour_primary_light,
                    borderRadius: "10px",
                    flexBasis: "20%",
                    marginRight: "10%"
                }}
                id={this.props.id}>{this.props.buttonText ? this.props.buttonText : "Send"}

            </button>
        }
    }
)

export default LimitedTouchAreaButton;